import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import _ from 'lodash';
import { format } from 'date-fns';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import {
    RadioGroup,
    Radio,
} from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { AddBoxIcon, IndeterminateCheckBoxIcon } from '../../../components/Icons/Icon';
import liveStreamDialogStyle from '../../../assets/jss/pages/liveStreamDialogStyle';
import Validation from '../../../common/Validation';
import SingleDatePickerSearch from '../../../components/DatePicker/SingleDatePickerSearch';
import CleanableInput from '../../../components/Input/CleanableInput';
import Button from '../../../components/Button/CustomButton';
import FormDialog from '../../../components/Dialog/FormDialog';
import CustomTypography from '../../../components/Typography/CustomTypography';
import SnackBar from '../../../components/Snackbar/Snackbar';
import TimeRanger from '../../../components/DatePicker/TimeRanger';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import InputHasUnit from '../../SeminarManagementOrganizer/inputHasUnit';
import UploadButton from '../../../components/Button/UploadButton';

const useStyles = makeStyles(liveStreamDialogStyle);

const titleDialog = () => (
    <Box>
        <CustomTypography variant="h6" bold color="info">
            ライブ配信情報編集
        </CustomTypography>
    </Box>
);

const LiveStreamDialog = (props) => {
    const {
        isOpen,
        handleIsClose,
        liveStreamId,
        eventName,
        fetchClearGetDetailLiveStream,
        fetchGetDetailLiveStream,
        fetchClearUpdateDetailLiveStream,
        fetchUpdateDetailLiveStream,
        detailLiveStream,
        eventStartDate,
        eventEndDate,
        updateLiveStreamSuccess,
        errors,
        eventInfo,
        detailLiveStreamErrors,
        fetchList,
    } = props;

    const classes = useStyles();
    const intl = useIntl();

    const [validateResults, setValidateResults] = useState({});
    const [tempDate, setTempDate] = useState('');
    const [tempIndex, setTempIndex] = useState('');
    const [isOpenSnackBar, setIsOpenSnackBar] = useState(false);
    const [messageSnackbar, setMessageSnackbar] = useState('');
    const [isOpenSnackBarFalse, setIsOpenSnackBarFalse] = useState(false);
    const [messageSnackbarFalse, setMessageSnackbarFalse] = useState('');
    const [params, setParams] = useState({});
    const [changeDataUpLoad, setChangeDataUpLoad] = useState({ changeDocument: false });
    const [checkLimit, setCheckLimit] = useState('1');
    const [checkCost, setCheckCost] = useState('1');
    const [errorsUpload, setErrorUpload] = useState(false);
    const [isOpenDialog, setIsOpenDialog] = useState(false);

    const hasCost = { yes: '1', no: '0' };
    const hasLimit = { yes: '1', no: '0' };

    useEffect(() => {
        if (isOpen) {
            fetchGetDetailLiveStream({ event_name: eventName, live_stream_id: liveStreamId });
        } else {
            fetchClearGetDetailLiveStream();
            fetchClearUpdateDetailLiveStream();
            setValidateResults({});
        }
    }, [isOpen]);

    useEffect(() => {
        if (!_.isEmpty(detailLiveStreamErrors)) {
            handleIsClose();
            setIsOpenSnackBarFalse(true);
            setMessageSnackbarFalse(detailLiveStreamErrors?.message?.message);
            fetchList();
        }
    }, [detailLiveStreamErrors]);

    useEffect(() => {
        if (!_.isEmpty(detailLiveStream)) {
            if (isOpen) setIsOpenDialog(true);
            setParams({
                ...detailLiveStream,
                documentPreview: detailLiveStream.document,
                limit: (+detailLiveStream.limit === -1 || !+detailLiveStream.limit) ? 0 : +detailLiveStream.limit,
            });
            if (!+detailLiveStream.limit || +detailLiveStream.limit === -1) {
                setCheckLimit('0');
            } else setCheckLimit('1');
            if (!+detailLiveStream.cost) {
                setCheckCost('0');
            } else setCheckCost('1');
        }
    }, [detailLiveStream]);

    useEffect(() => {
        if (tempDate && !_.isUndefined(tempIndex) && !_.isEmpty(params.dates)) {
            const tempArrDate = [];
            params.dates.forEach((item, index) => {
                if (index === tempIndex) {
                    tempArrDate.push({ id: item.id || null, date: tempDate, is_registered: false });
                } else {
                    tempArrDate.push(item);
                }
            });
            setParams({ ...params, dates: tempArrDate });
            setTempDate('');
            setTempIndex('');
        }
    }, [tempDate, tempIndex]);

    useEffect(() => {
        if (updateLiveStreamSuccess) {
            setIsOpenDialog(false);
            handleIsClose();
            setIsOpenSnackBar(true);
            setMessageSnackbar('ライブ配信を更新しました。');
        } else if (!updateLiveStreamSuccess && !_.isEmpty(errors) && errors.code === 'BAD_REQUEST') {
            setIsOpenSnackBarFalse(true);
            setMessageSnackbarFalse(errors?.message?.message);
            fetchClearUpdateDetailLiveStream();
        }
    }, [updateLiveStreamSuccess, errors]);

    const handleSetParams = useCallback((field, valueChange) => {
        setParams((prevParams) => ({ ...prevParams, [field]: valueChange }));
    }, []);

    const actionsButton = () => (
        <Box style={{ margin: 'auto' }}>
            <Button
                autoFocus
                gradient
                onClick={handleSubmit}
                size="md"
                color="success"
                className={classes.btn}
                style={{ width: '200px', fontSize: '20px', left: ' 20%' }}
            >
                {intl.formatMessage({ id: 'save' })}
            </Button>
            <Button
                autoFocus
                gradient
                onClick={handleCloseDialog}
                size="md"
                color="danger"
                style={{ width: '150px', marginRight: '10px', left: ' 80%' }}
            >
                {intl.formatMessage({ id: 'cancel' })}
            </Button>
        </Box>
    );

    const dateArray = () => {
        const date = [];
        (params.dates || []).map((item) => (
            date.push(item.date)
        ));
        return date;
    };

    const validate = () => {
        const {
            title, speaker, stime, etime, dates, fee, url_live_stream, inquiry, survey_link, document_link,
            title_en, speaker_en,
        } = params;

        const validateRules = {
            title: [
                () => Validation.isNotEmpty(title),
                () => Validation.validateMaxLength(title, 500),
            ],
            speaker: [
                () => Validation.isNotEmpty(speaker),
                () => Validation.validateMaxLength(speaker, 255),
            ],
            dates: [
                () => Validation.validateDuplicateDates(dateArray()),
                () => Validation.validateArr(dateArray()),
            ],
            rangerTime: [() => Validation.validateTimeRanger(stime, etime),
                () => Validation.validateTimeSame(stime, etime),
                () => Validation.validateStartTime(stime, dateArray()),
            ],
            url_live_stream: [
                () => Validation.isValidIframeAndHttp(url_live_stream),
            ],
            streamer_profile: [
                () => Validation.validateMaxLength(params.streamer_profile, 300),
            ],
            content: [
                () => Validation.isNotEmpty(params.content),
                () => Validation.validateMaxLength(params.content, 300),
            ],
            document_link: [
                () => Validation.validateMaxLength(document_link, 500),
                () => Validation.isValidUrl(document_link),
            ],
            survey_link: [
                () => Validation.validateMaxLength(survey_link, 500),
                () => Validation.isValidUrl(survey_link),
            ],
            inquiry: [() => Validation.validateMaxLength(inquiry, 100),
                () => Validation.validateEmail(inquiry),
            ],
        };

        if (!eventInfo.free_live_stream && checkLimit === '1') {
            validateRules.limit = [
                () => Validation.isNotEmpty(params.limit),
                () => Validation.isInt(params.limit),
                () => Validation.isNumberNotZero(params.limit),
            ];
        }
        if (!eventInfo.free_live_stream && checkCost === '1' && eventInfo.has_shopping_cart) {
            validateRules.cost = [
                () => Validation.isNotEmpty(params.cost),
                () => Validation.isInt(params.cost),
                () => Validation.isNumberNotZero(params.cost),
            ];
        }
        if (!_.isEmpty(eventInfo.languages)) {
            validateRules.title_en = [
                () => Validation.isNotEmpty(title_en),
                () => Validation.validateLatin(title_en),
                () => Validation.validateMaxLength(title_en, 500),
            ];
            validateRules.speaker_en = [
                () => Validation.isNotEmpty(speaker_en),
                () => Validation.validateLatin(speaker_en),
                () => Validation.validateMaxLength(speaker_en, 255),
            ];
            validateRules.content_en = [
                () => Validation.isNotEmpty(params.content_en),
                () => Validation.validateLatin(params.content_en),
                () => Validation.validateMaxLength(params.content_en, 300),
            ];
        }
        const validateResult = Validation.validateAllRules(validateRules);
        if (Object.keys(validateResult).length > 0) {
            setValidateResults({ ...validateResult });
            window.scrollTo(0, 0);
            return false;
        }
        setValidateResults({});
        return true;
    };

    const formatDate = (data) => (format(new Date(data), 'yyyy-MM-dd'));

    const handleChangeDate = (sdate, index) => {
        setTempIndex(index);
        setTempDate(formatDate(sdate));
    };

    const handleUploadDocument = (file) => {
        setErrorUpload(false);
        handleSetParams('document', file);
        setChangeDataUpLoad({ changeDocument: true });
    };

    const addDate = () => {
        const value = formatDate(new Date());
        setParams({ ...params, dates: [...params.dates, { id: null, date: value, is_registered: false }] });
    };

    const removeDate = (key) => {
        params.dates.splice(key, 1);
        const tempArrDate = params.dates;
        setParams({ ...params, dates: tempArrDate });
    };

    const checkUndefined = (values) => (!_.isUndefined(values) ? values.trim() : '');

    const handleSubmit = () => {
        if (validate() && !errorsUpload) {
            let dataSb = {
                event_name: eventName,
                live_stream_id: liveStreamId,
                data: {
                    title: checkUndefined(params.title),
                    speaker: checkUndefined(params.speaker),
                    stime: params.stime,
                    etime: params.etime,
                    dates: JSON.stringify(params.dates),
                    url_live_stream: checkUndefined(params.url_live_stream),
                    streamer_profile: checkUndefined(params.streamer_profile),
                    content: checkUndefined(params.content),
                    document_link: checkUndefined(params.document_link),
                    survey_link: checkUndefined(params.survey_link),
                    inquiry: checkUndefined(params.inquiry),
                    limit: -1,
                },
            };
            if (!_.isEmpty(eventInfo.languages)) {
                dataSb = {
                    ...dataSb,
                    data: {
                        ...dataSb.data,
                        title_en: checkUndefined(params.title_en),
                        speaker_en: checkUndefined(params.speaker_en),
                        content_en: checkUndefined(params.content_en),
                    },
                };
            }
            if (!eventInfo.free_live_stream) {
                dataSb = {
                    ...dataSb,
                    data: {
                        ...dataSb.data,
                        cost: 0,
                    },
                };
            }
            if (eventInfo.has_shopping_cart && !eventInfo.free_live_stream) {
                dataSb = {
                    ...dataSb,
                    data: {
                        ...dataSb.data,
                        cost: +params.cost,
                        limit: +params.limit ? +params.limit : -1,
                    },
                };
            }
            if (changeDataUpLoad.changeDocument) {
                dataSb = {
                    ...dataSb,
                    data: {
                        ...dataSb.data,
                        document: (changeDataUpLoad.changeDocument && params.document) || '',
                    },
                };
            }
            setChangeDataUpLoad({ changeDocument: false });
            fetchUpdateDetailLiveStream(dataSb);
        }
    };

    const handleCloseDialog = () => {
        handleIsClose();
        setIsOpenDialog(false);
        setChangeDataUpLoad({ changeDocument: false });
    };

    const handleChangeNumber = (field, value) => {
        if (field === 'limit') {
            setCheckLimit(value);
            if (!+value) {
                handleSetParams(field, 0);
            }
        }
        if (field === 'cost') {
            setCheckCost(value);
            if (!+value) {
                handleSetParams(field, 0);
            }
        }
    };

    return (
        <>
            <FormDialog title={titleDialog()} isOpen={isOpenDialog} handleClose={handleCloseDialog} actions={actionsButton()}>
                <GridContainer>
                    <GridItem className={classes.spacing}>
                        <GridContainer>
                            <GridItem xs={12} md={3} sm={4}>
                                <CustomTypography required>
                                    {!_.isEmpty(eventInfo.languages) ? 'タイトル（和文）' : 'タイトル'}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={9} sm={8}>
                                <CleanableInput
                                    defaultValue={params.title}
                                    onChange={(value) => handleSetParams('title', value)}
                                    error={!!validateResults.title}
                                    helperText={validateResults.title
                                        ? intl.formatMessage({ id: validateResults.title.message }, { maxLength: 500 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    {!_.isEmpty(eventInfo.languages) && (
                        <GridItem className={classes.spacing}>
                            <GridContainer>
                                <GridItem xs={12} md={3} sm={4}>
                                    <CustomTypography required>
                                        タイトル（英文）
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={9} sm={8}>
                                    <CleanableInput
                                        defaultValue={params.title_en}
                                        onChange={(value) => handleSetParams('title_en', value)}
                                        error={!!validateResults.title_en}
                                        helperText={validateResults.title_en
                                            ? intl.formatMessage({ id: validateResults.title_en.message }, { maxLength: 500 }) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    )}
                    <GridItem className={classes.spacing}>
                        <GridContainer>
                            <GridItem xs={12} md={3} sm={4}>
                                <CustomTypography required>
                                    {!_.isEmpty(eventInfo.languages) ? '出演者（和文）' : '出演者'}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={9} sm={8}>
                                <CleanableInput
                                    defaultValue={params.speaker}
                                    onChange={(value) => handleSetParams('speaker', value)}
                                    error={!!validateResults.speaker}
                                    helperText={validateResults.speaker
                                        ? intl.formatMessage({ id: validateResults.speaker.message }, { maxLength: 255 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    {!_.isEmpty(eventInfo.languages) && (
                        <GridItem className={classes.spacing}>
                            <GridContainer>
                                <GridItem xs={12} md={3} sm={4}>
                                    <CustomTypography required>
                                        出演者（英文）
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={9} sm={8}>
                                    <CleanableInput
                                        defaultValue={params.speaker_en}
                                        onChange={(value) => handleSetParams('speaker_en', value)}
                                        error={!!validateResults.speaker_en}
                                        helperText={validateResults.speaker_en
                                            ? intl.formatMessage({ id: validateResults.speaker_en.message }, { maxLength: 255 }) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    )}
                    <GridItem className={classes.spacing}>
                        <GridContainer>
                            <GridItem xs={12} md={3} sm={4}>
                                <CustomTypography required>
                                    日程
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={9} sm={8} style={{ padding: '0px' }}>
                                {
                                    (params.dates || []).map((date, index) => (
                                        <GridContainer style={{ marginBottom: '20px' }}>
                                            <GridItem xs={6} md={6}>
                                                <SingleDatePickerSearch
                                                    onChange={(value) => handleChangeDate(value, index)}
                                                    defaultValue={date.date}
                                                    format="yyyy/MM/dd"
                                                    error={!!validateResults.dates}
                                                    minDate={new Date(eventStartDate)}
                                                    maxDate={new Date(eventEndDate)}
                                                    disabled={date.is_registered}
                                                />
                                            </GridItem>
                                            <GridItem xs={6} md={6}>
                                                <IconButton
                                                    size="small"
                                                    classes={{ root: classes.roomRemoveButton }}
                                                    onClick={() => removeDate(index)}
                                                    disabled={date.is_registered}
                                                >
                                                    <IndeterminateCheckBoxIcon />
                                                </IconButton>
                                            </GridItem>
                                        </GridContainer>
                                    ))
                                }
                                {!!validateResults.dates && (
                                    <GridContainer>
                                        <CustomTypography color="danger" className={classes.errorText}>
                                            ライブ配信で異なる日付を入力してください。
                                        </CustomTypography>
                                    </GridContainer>
                                )}
                                <GridContainer>
                                    <GridItem style={{ marginTop: '10px' }}>
                                        <IconButton
                                            size="small"
                                            classes={{ root: classes.roomAddButton }}
                                            onClick={addDate}
                                        >
                                            <AddBoxIcon />
                                        </IconButton>
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                    </GridItem>

                    <GridItem className={classes.spacing}>
                        <GridContainer>
                            <GridItem xs={12} md={3} sm={4}>
                                <CustomTypography required>
                                    時間帯
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={9} sm={8}>
                                <TimeRanger
                                    defaultStartTime={params.stime}
                                    defaultEndTime={params.etime}
                                    onChangeStartTime={(stime) => handleSetParams('stime', stime)}
                                    onChangeEndTime={(etime) => handleSetParams('etime', etime)}
                                    error={{
                                        stime: !!validateResults.stime,
                                        etime: !!validateResults.etime,
                                        rangerTime: !!validateResults.rangerTime,
                                    }}
                                    helperTexts={{
                                        stime: validateResults.stime
                                            ? intl.formatMessage({ id: validateResults.stime.message }) : '',
                                        etime: validateResults.etime
                                            ? intl.formatMessage({ id: validateResults.etime.message }) : '',
                                        rangerTime: validateResults.rangerTime
                                            ? intl.formatMessage({ id: validateResults.rangerTime.message }) : '',
                                    }}
                                />
                            </GridItem>
                        </GridContainer>
                    </GridItem>

                    <GridItem className={classes.spacing}>
                        <GridContainer>
                            <GridItem xs={12} md={3} sm={4}>
                                <CustomTypography>
                                    出演者プロフィール
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={9} sm={8}>
                                <CleanableInput
                                    defaultValue={params.streamer_profile}
                                    onChange={(valueInput) => handleSetParams('streamer_profile', valueInput)}
                                    isMultiline
                                    row="3"
                                    error={!!validateResults.streamer_profile}
                                    helperText={validateResults.streamer_profile
                                        ? intl.formatMessage(
                                            { id: validateResults.streamer_profile.message },
                                            { maxLength: 300 },
                                        ) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                    </GridItem>

                    <GridItem className={classes.spacing}>
                        <GridContainer>
                            <GridItem xs={12} md={3} sm={4}>
                                <CustomTypography required>
                                    {!_.isEmpty(eventInfo.languages) ? '配信内容（和文）' : '配信内容'}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={9} sm={8}>
                                <CleanableInput
                                    defaultValue={params.content}
                                    onChange={(valueInput) => handleSetParams('content', valueInput)}
                                    isMultiline
                                    row="3"
                                    error={!!validateResults.content}
                                    helperText={validateResults.content
                                        ? intl.formatMessage(
                                            { id: validateResults.content.message },
                                            { maxLength: 300 },
                                        ) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    {!_.isEmpty(eventInfo.languages) && (
                        <GridItem className={classes.spacing}>
                            <GridContainer>
                                <GridItem xs={12} md={3} sm={4}>
                                    <CustomTypography required>
                                        配信内容（英文）
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={9} sm={8}>
                                    <CleanableInput
                                        defaultValue={params.content_en}
                                        onChange={(valueInput) => handleSetParams('content_en', valueInput)}
                                        isMultiline
                                        row="3"
                                        error={!!validateResults.content_en}
                                        helperText={validateResults.content_en
                                            ? intl.formatMessage(
                                                { id: validateResults.content_en.message },
                                                { maxLength: 300 },
                                            ) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    )}
                    {!eventInfo.free_live_stream && eventInfo.has_shopping_cart && (
                        <GridItem className={classes.spacing}>
                            <GridContainer style={{ alignItems: 'center' }}>
                                <GridItem xs={12} md={3} sm={4}>
                                    <CustomTypography required>
                                        申込最大人数
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={11} md={3} sm={8}>
                                    <RadioGroup
                                        aria-label="limit"
                                        name="limit"
                                        value={checkLimit === '1'}
                                        onChange={(e) => handleChangeNumber('limit', e.target.value)}
                                        row
                                    >
                                        <FormControlLabel
                                            value={hasLimit.no}
                                            control={<Radio color="primary" checked={checkLimit === '0'} />}
                                            label="なし"
                                            className={classes.radioButton}
                                        />
                                        <FormControlLabel
                                            value={hasLimit.yes}
                                            control={<Radio color="primary" checked={checkLimit === '1'} />}
                                            label="あり"
                                            className={classes.radioButton}
                                        />
                                    </RadioGroup>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    )}
                    {!eventInfo.free_live_stream && eventInfo.has_shopping_cart && (
                        <GridItem>
                            <GridContainer style={{ margin: '0 15px' }}>
                                <GridItem xs={12} md={3} sm={4} />
                                <GridItem xs={11} md={3} sm={8} style={{ paddingLeft: '7px' }}>
                                    <InputHasUnit
                                        disabled={checkLimit === '0'}
                                        defaultValue={`${params.limit}`}
                                        onChange={(valueInput) => handleSetParams('limit', valueInput)}
                                        error={!!validateResults.limit}
                                        helperText={validateResults.limit
                                            ? intl.formatMessage(
                                                { id: validateResults.limit.message },
                                            ) : ''}
                                        unit="人"
                                        minValue={0}
                                        maxValue={1000000}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    )}

                    <GridItem className={classes.spacing}>
                        <GridContainer>
                            <GridItem xs={12} md={3} sm={4}>
                                <CustomTypography>
                                    資料
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={9} sm={8}>
                                <UploadButton
                                    text=""
                                    type="document"
                                    onChange={(file) => handleUploadDocument(file)}
                                    namePreview={params.documentPreview}
                                    errors={(value) => setErrorUpload(value)}
                                />
                            </GridItem>
                        </GridContainer>
                    </GridItem>

                    <GridItem className={classes.spacing}>
                        <GridContainer>
                            <GridItem xs={12} md={3} sm={4}>
                                <CustomTypography>
                                    資料請求受付
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={9} sm={8}>
                                <CleanableInput
                                    defaultValue={params.document_link}
                                    onChange={(valueInput) => handleSetParams('document_link', valueInput)}
                                    error={!!validateResults.document_link}
                                    helperText={validateResults.document_link
                                        ? intl.formatMessage(
                                            { id: validateResults.document_link.message },
                                            { maxLength: 500 },
                                        ) : ''}
                                />
                                <CustomTypography>
                                    ＊ＵＲＬを入力してください。
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                    </GridItem>

                    <GridItem className={classes.spacing}>
                        <GridContainer>
                            <GridItem xs={12} md={3} sm={4}>
                                <CustomTypography>
                                    アンケート
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={9} sm={8}>
                                <CleanableInput
                                    defaultValue={params.survey_link}
                                    onChange={(valueInput) => handleSetParams('survey_link', valueInput)}
                                    error={!!validateResults.survey_link}
                                    helperText={validateResults.survey_link
                                        ? intl.formatMessage(
                                            { id: validateResults.survey_link.message },
                                            { maxLength: 500 },
                                        ) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                    </GridItem>

                    <GridItem className={classes.spacing}>
                        <GridContainer>
                            <GridItem xs={12} md={3} sm={4}>
                                <CustomTypography>
                                    お問合せ
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={9} sm={8}>
                                <CleanableInput
                                    defaultValue={params.inquiry}
                                    onChange={(valueInput) => handleSetParams('inquiry', valueInput)}
                                    error={!!validateResults.inquiry}
                                    helperText={validateResults.inquiry
                                        ? intl.formatMessage(
                                            { id: validateResults.inquiry.message },
                                            { maxLength: 100 },
                                        ) : ''}
                                />
                                <CustomTypography>
                                    ＊メールアドレスを入力してください。
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                    </GridItem>

                    {!eventInfo.free_live_stream && eventInfo.has_shopping_cart && (
                        <GridItem className={classes.spacing}>
                            <GridContainer style={{ alignItems: 'center' }}>
                                <GridItem xs={12} md={3} sm={4}>
                                    <CustomTypography required>
                                        料金
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={5} sm={8} style={{ paddingLeft: '21px' }}>
                                    <RadioGroup
                                        aria-label="cost"
                                        name="cost"
                                        value={checkCost === '1'}
                                        onChange={(e) => handleChangeNumber('cost', e.target.value)}
                                        row
                                    >
                                        <FormControlLabel
                                            value={hasCost.no}
                                            control={<Radio color="primary" checked={checkCost === '0'} />}
                                            label="無料"
                                            className={classes.radioButton}
                                        />
                                        <FormControlLabel
                                            value={hasCost.yes}
                                            control={<Radio color="primary" checked={checkCost === '1'} />}
                                            label="有料"
                                            className={classes.radioButton}
                                        />
                                    </RadioGroup>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    )}

                    {!eventInfo.free_live_stream && eventInfo.has_shopping_cart && (
                        <GridItem style={{ margin: '0 15px 15px' }}>
                            <GridContainer>
                                <GridItem xs={12} md={3} sm={4} />
                                <GridItem xs={11} md={4} sm={3} style={{ padding: '0px' }}>
                                    <GridContainer>
                                        <GridItem className={checkCost === '1' ? classes.rightInput : classes.rightInputDisable}>
                                            <InputHasUnit
                                                disabled={checkCost === '0'}
                                                defaultValue={+params.cost}
                                                onChange={(valueInput) => handleSetParams('cost', valueInput)}
                                                unit="円"
                                                minValue={0}
                                                error={!!validateResults.cost}
                                                helperText={validateResults.cost
                                                    ? intl.formatMessage(
                                                        { id: validateResults.cost.message },
                                                    ) : ''}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    )}

                    <GridItem className={classes.spacing}>
                        <GridContainer>
                            <GridItem xs={12} md={3} sm={4}>
                                <CustomTypography>
                                    ライブ配信を見るURL
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={9} sm={8}>
                                <CleanableInput
                                    defaultValue={params.url_live_stream}
                                    onChange={(value) => handleSetParams('url_live_stream', value.trim())}
                                    error={!!validateResults.url_live_stream}
                                    helperText={validateResults.url_live_stream
                                        ? intl.formatMessage({ id: validateResults.url_live_stream.message }, { maxLength: 20 }) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                </GridContainer>
            </FormDialog>

            <SnackBar
                open={isOpenSnackBar}
                onClose={() => setIsOpenSnackBar(false)}
                message={messageSnackbar}
                severity="success"
                autoHideDuration={3000}
            />

            <SnackBar
                open={isOpenSnackBarFalse}
                onClose={() => setIsOpenSnackBarFalse(false)}
                message={messageSnackbarFalse}
                severity="error"
                autoHideDuration={3000}
            />
        </>
    );
};

LiveStreamDialog.defaultProps = {
    isOpen: false,
    liveStreamId: 0,
    detailLiveStream: {},
    updateLiveStreamSuccess: false,
    errors: {},
    eventInfo: {},
    detailLiveStreamErrors: {},
    fetchList: () => {},
};

LiveStreamDialog.propTypes = {
    isOpen: PropTypes.bool,
    handleIsClose: PropTypes.func.isRequired,
    liveStreamId: PropTypes.number,
    eventName: PropTypes.string.isRequired,
    fetchClearGetDetailLiveStream: PropTypes.func.isRequired,
    fetchGetDetailLiveStream: PropTypes.func.isRequired,
    fetchClearUpdateDetailLiveStream: PropTypes.func.isRequired,
    fetchUpdateDetailLiveStream: PropTypes.func.isRequired,
    detailLiveStream: PropTypes.oneOfType([() => null, PropTypes.object]),
    eventStartDate: PropTypes.string.isRequired,
    eventEndDate: PropTypes.string.isRequired,
    updateLiveStreamSuccess: PropTypes.bool,
    errors: PropTypes.oneOfType([() => null, PropTypes.object]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    detailLiveStreamErrors: PropTypes.oneOfType([() => null, PropTypes.object]),
    fetchList: PropTypes.func,
};

export default LiveStreamDialog;
